module.exports = __webpack_public_path__ + "static/img/answer_right.a00f631.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/answer_right.png
// module id = ACnE
// module chunks = 1